import { useState } from 'react'
import _ from 'lodash'

export default initialState => {
  const [state, setState] = useState(initialState)

  const setProp = (propName, value) => {
    setState(prev => ({
      ...prev,
      [propName]: _.isFunction(value) ? value(prev) : value,
    }))
  }

  const reset = () => {
    setState(initialState)
  }

  return [state, setProp, setState, reset]
}
